import {Permission, PermissionType} from '@hconnect/apiclient'
import {parseDataScope} from '@hconnect/common/hproduce/whiteListCheck'
import {
  getPlantIdsPerCountryMap,
  type PlantIdsPerCountryMap,
  useUpmPlantsContext
} from '@hconnect/upm'
import {useMemo} from 'react'

import {usePermissionsContext} from './usePermission'

export const getPlantIdsForPermissions = (
  permissions: Permission[],
  plantIdsForCountryMap: PlantIdsPerCountryMap
) => {
  const plantIdsSet = new Set<string>()

  permissions.forEach(({dataScope}) => {
    const {plantId, countryId} = parseDataScope(dataScope)

    if (plantId) {
      plantIdsSet.add(plantId)
    } else if (countryId) {
      plantIdsForCountryMap[countryId]?.forEach((id) => plantIdsSet.add(id))
    }
  })

  return Array.from(plantIdsSet)
}

export const usePlantsByPermission = (permission: PermissionType) => {
  const permissions = usePermissionsContext()
  const filteredPermissions = permissions.filter((p) => p.permissionType === permission)

  const upmPlants = useUpmPlantsContext()
  const plantIdsForCountryMap = getPlantIdsPerCountryMap(upmPlants)

  const plantIds = getPlantIdsForPermissions(filteredPermissions, plantIdsForCountryMap)

  return {plantIds}
}

export const usePlantsByPermissions = (permissionsToCheck: PermissionType[]) => {
  const permissions = usePermissionsContext()
  const filteredPemissions = useMemo(() => {
    return permissions.filter((pe) => permissionsToCheck.some((p) => pe.permissionType === p))
  }, [permissions, permissionsToCheck])

  const upmPlants = useUpmPlantsContext()
  const plantIdsForCountryMap = getPlantIdsPerCountryMap(upmPlants)

  const plantIds = getPlantIdsForPermissions(filteredPemissions, plantIdsForCountryMap)

  return {plantIds}
}
